export default __webpack_public_path__ + "static/media/crutches.a28ff771.png";